import { render } from "./SimpleNoteCreate.vue?vue&type=template&id=3be64646&scoped=true"
import script from "./SimpleNoteCreate.vue?vue&type=script&lang=js"
export * from "./SimpleNoteCreate.vue?vue&type=script&lang=js"

import "./SimpleNoteCreate.vue?vue&type=style&index=0&id=3be64646&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be64646"]])

export default __exports__